module.exports = __webpack_public_path__ + "media/assets/icons/reflection-footer-bg-af5da6fc1a52084e788a4561b528b959.png";